import chileanRut from 'chilean-rut'

/**
 * Valida que el rut sea valido
 * @param {*} rut
 * @returns //{ valid: boolean, rut: '' }
 */
const validarRut = (rut) => {
  if (rut && rut.length >= 6) {
    const unformatedRut = chileanRut.unformat(rut)
    let rutFormated = `${getRutSinDigitoVerificador(
      unformatedRut
    )}-${getDigitoVerificadorRut(unformatedRut)}`
    return {
      valid: chileanRut.validate(rut.toUpperCase()),
      rut: rutFormated.toUpperCase()
    }
  }
  return { valid: false, rut: '' }
}

/**
 *
 * @param {*} rut
 * @returns
 */
const unFormat = (rut) => {
  if (rut && rut.length >= 8 && validarRut(rut).valid) {
    return chileanRut.unformat(rut)
  }
  return null
}

const format = (rut) => {
  if (validarRut(rut).valid) {
    return `${getRutSinDigitoVerificador(rut)}-${getDigitoVerificadorRut(rut)}`
  } else return null
}

/**
 * retorna el digito verificador del rut
 * @param {*} rut
 * @returns
 */
const getDigitoVerificadorRut = (rut) => {
  return chileanRut.getValidatorDigit(getRutSinDigitoVerificador(rut))
}

/**
 * Retorna el rut sin digito verificador
 * @param {*} rut
 * @returns
 */
const getRutSinDigitoVerificador = (rut) => {
  return rut.slice(0, -1)
}

export const rutFunctionsHelpers = {
  validarRut: validarRut,
  getDigitoVerificadorRut: getDigitoVerificadorRut,
  getRutSinDigitoVerificador: getRutSinDigitoVerificador,
  unFormat: unFormat,
  format: format
}
